import _ from 'lodash';
import React, {useCallback, useEffect, useMemo} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import {FmlxComboBox} from 'fmlx-common-ui';
import {useSelector} from 'react-redux';
import practiceBusiness from '../../stores/business/practiceBusiness';
import {resetPractices, setSelectedPractice} from '../../stores/actions/practiceAction';
/**
 * @deprecated
 * Avoid using PracticeDropdown component.
 *
 * This component handles internal state (e.g. fetch, dispatch, auto-select),
 * which should be managed in the page level for better control and reusability.
 *
 * Use <FmlxComboBox /> directly in the page and handle data, selection, and events externally.
 */
function PracticeDropdown({callbackChangePractice, department, practiceValue, onClearValue}) {
  const dispatch = useDispatch();
  const practiceMap = useSelector((state) => state.practiceState.practices);
  const selectedPractice = useSelector((state) => state.practiceState.selectedPractice);

  const practiceList = useMemo(() => {
    if (!department?.id) return [];
    return practiceMap[department.id] || [];
  }, [practiceMap, department?.id]);

  useEffect(() => {
    if (department?.id) {
      dispatch(practiceBusiness.fetchPracticesByDepartment(department.id));
    }
    return dispatch(resetPractices());
  }, [department?.id, dispatch]);

  useEffect(() => {
    if (practiceValue && !selectedPractice) {
      dispatch(setSelectedPractice(_.cloneDeep(practiceValue)));
    }
  }, [practiceValue, selectedPractice, dispatch]);

  const handleDropDownChange = useCallback(
    (value) => {
      dispatch(setSelectedPractice(value));
      if (value) {
        callbackChangePractice(value.data);
      } else {
        callbackChangePractice(null);
      }
    },
    [callbackChangePractice, dispatch]
  );

  const handleClear = useCallback(() => {
    dispatch(setSelectedPractice(null));
    callbackChangePractice(null);
    if (onClearValue) onClearValue();
  }, [callbackChangePractice, onClearValue, dispatch]);

  return (
    <FmlxComboBox
      id={'practiceDropdown'}
      loading={!practiceMap[department?.id]}
      placeholder="Practice"
      items={practiceList}
      selectedItem={selectedPractice}
      onClearInputValue={handleClear}
      showClearChip
      showClearInput
      onChange={handleDropDownChange}
    />
  );
}

PracticeDropdown.propTypes = {
  callbackChangePractice: PropTypes.func,
  department: PropTypes.object,
  practiceValue: PropTypes.any,
};

PracticeDropdown.defaultProps = {
  callbackChangePractice: () => {},
  department: null,
  practiceValue: null,
};

export default PracticeDropdown;
